import {useSetTimeout} from '../../../Custom Hooks/useSetTimeout/useSetTimeout';
import {useEffect, useState} from 'react';
import {IImageManual} from '../../../pages/RandomSampler/Config/RandomSampler.types';


const useRandomSamplerClasses = (setState, randomSamplerState, addImageToClassReference) => {
    const {_setTimeOut} = useSetTimeout();
    const [hasDropdownChanged, setHasDropdownChanged] = useState(false);

    /**
     * handleDropdownChange - change state due to dropdown change
     */
    const handleDropdownChange = (key: string, value: string) => {
        setState({ [key]: value });
        setHasDropdownChanged(true);
    };

    /**
     * addClass - add class to random images (not saving in server yet)
     */
    const addClass = () => {
        const isClassNameIsAllow = !randomSamplerState.addClassError && randomSamplerState.newClassInput.length > 0;

        if (isClassNameIsAllow) {
            const copyClasses = JSON.parse(JSON.stringify(randomSamplerState.classes));
            const isClassExistInProject = copyClasses.filter((cl) => cl.name.toLowerCase() === randomSamplerState.newClassInput.toLowerCase()).length > 0;

            if (isClassExistInProject) {
                const errorMsg = 'Class already exist';

                setState({globalClassError: errorMsg});
            } else {
                copyClasses.push({isChosen: false, tagId: 0, name: randomSamplerState.newClassInput, img:
                        {
                            fileServerId: -1,
                            url: 'error',
                            title: 'error',
                            approved: false}});
                setState({classes: copyClasses, newClassInput: '', isAddClass: false, addClassError: ''});
            }
        } else {
            setState({newClassInput: '', isAddClass: false, addClassError: ''});
        }
    };

    /**
     * pressOnAddImagesBtn - when user press on add button (add images to class)
     * @param classIndex - classIndex class index of chosen one
     */
    const pressOnAddImagesBtn = (classIndex) => {
        const copyClasses = JSON.parse(JSON.stringify(randomSamplerState.classes));

        copyClasses[classIndex].isChosen = true;
        setState({classes: copyClasses, classIndex, isCleanClick: false, globalLoading: true});
    };

    /**
     * sendImagesToDb - send to server images to add to class
     */
    const sendImagesToDb = () => {
        const copyClasses = JSON.parse(JSON.stringify(randomSamplerState.classes));
        const copyManualImages = JSON.parse(JSON.stringify(randomSamplerState.manualImages));
        const imagesForDb:IImageManual[] = [];

        copyManualImages.forEach((img) => {
            if (img.approved) {
                img.tagId = randomSamplerState.classes[randomSamplerState.classIndex].tagId;
                img.disable = true;
                img.disableTitle = randomSamplerState.classes[randomSamplerState.classIndex].name;

                imagesForDb.push(img);
            }
        });
        addImageToClassReference(imagesForDb, copyManualImages, copyClasses);
    };

    /**
     * setUiAfterAddingImages - set UI after addImageToClassReference (sendImagesToDb)
     */
    const setUiAfterAddingImages = () => {
        const copyClasses = JSON.parse(JSON.stringify(randomSamplerState.classes));
        const copyManualImages = JSON.parse(JSON.stringify(randomSamplerState.manualImages));

        _setTimeOut(() => {
            if (copyClasses[randomSamplerState.classIndex].isShowAddToClassError) {
                copyManualImages.forEach((img) => {
                    if (img.approved && img.tagId === copyClasses[randomSamplerState.classIndex].tagId) {
                        img.approved = false;
                        img.isSendToDelete = false;
                        img.tagId = -1;
                        img.disable = false;
                        img.disableTitle = '';
                        img.isSendToDelete = false;
                    }
                });
            } else {
                copyManualImages.forEach((img) => {
                    if (img.approved) {
                        img.approved = false;
                    }
                });
            }

            copyClasses[randomSamplerState.classIndex].isShowAddToClassSuccess = false;
            copyClasses[randomSamplerState.classIndex].isShowAddToClassError = false;
            copyClasses[randomSamplerState.classIndex].isChosen = false;
            setState({manualImages: copyManualImages, classes: copyClasses, classIndex: -1, globalLoading: false});
        }, 1000);
    };

    useEffect(() => {
        if (randomSamplerState.classIndex > -1) {
            const classChosen = randomSamplerState.classes[randomSamplerState.classIndex];
            const isSendToServerAddToClassImages = classChosen.isChosen && !classChosen.isShowAddToClassSuccess && !classChosen.isShowAddToClassError;
            const isAfterServerAddToClassImages = classChosen.isChosen && (classChosen.isShowAddToClassSuccess || classChosen.isShowAddToClassError);

            isSendToServerAddToClassImages && sendImagesToDb();
            isAfterServerAddToClassImages && setUiAfterAddingImages();
        }
    }, [randomSamplerState.classIndex, JSON.stringify(randomSamplerState.classes)]);

    return {
        pressOnAddImagesBtn,
        addClass,
        hasDropdownChanged,
        handleDropdownChange,
        setHasDropdownChanged
    };
};

export default useRandomSamplerClasses;
